var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"release-container"}},[_c('div',{staticClass:"title-release"},[_vm._v(" "+_vm._s(_vm.data.title)+" ")]),_c('div',{staticClass:"content-release",domProps:{"innerHTML":_vm._s(_vm.data)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }